import styled from "styled-components";

const NoUsersToShow = styled.span `
  font-style: italic;
  display: block;
  text-align: center;
`;

export default NoUsersToShow;
